import { useMemo } from 'react';

import dayjs from 'dayjs';

import { useUnauthorizedEventsQuery } from '@queries/EventQueries';
import { Series } from '@queries/TagQueries';
import { useCurrentUser } from '@queries/UserQueries';

import { useRouter } from '@router/index';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';

import stageIconUrl from '../../CommunityScreen/assets/stage.svg';

export const LineupReferralSection = ({
  tagSlug,
  series,
}: {
  tagSlug: string;
  series?: Series;
}) => {
  const { navigate } = useRouter();
  const { currentUser } = useCurrentUser();
  const { eventsAreReady, events = [] } = useUnauthorizedEventsQuery(
    {
      tagIds: [series?._id],
      startDate: dayjs().format('YYYY-MM-DD'),
      rsvpData: 'ignore',
    },
    Boolean(series?._id),
  );

  const isLinueupReferralSectionVisible = useMemo(() => {
    return events.some((event) => (event as any)?.referralUrls?.[currentUser?._id ?? '']);
  }, [currentUser?._id]);

  if (!isLinueupReferralSectionVisible) {
    return <></>;
  }

  return (
    <div
      className="relative"
      style={{
        background: 'rgba(255,255,255,.1)',
        borderRadius: 8,
        overflow: 'hidden',
      }}
      onClick={() => {
        navigate(`/noauth/series/${tagSlug}/linuep-referral`);
      }}
    >
      <div className="d-flex gap-2 align-items-center py-1">
        <div className="flex-shrink-0">
          <div className="d-flex align-items-center ps-3 pe-1" style={{ width: 60, height: 60 }}>
            <img
              src={stageIconUrl}
              style={{
                width: 40,
                height: 40,
                display: 'block',
                margin: '0 auto',
                objectFit: 'contain',
                borderRadius: 4,
                overflow: 'hidden',
              }}
            />
          </div>
        </div>
        <div>
          <div>
            <strong>Lineup Confirmations</strong>
          </div>
          <div style={{ opacity: 0.75, lineHeight: 1.3, fontSize: '.8rem' }}>
            <span>Help us confirm show lineups and get rewarded!</span>
          </div>
        </div>
        <div className="ml-auto px-3">
          <FontAwesomeIcon name="chevron-right" />
        </div>
      </div>
    </div>
  );
};
